import React, { useRef, useState } from 'react';
// eslint-disable-next-line import/no-unresolved
import { Swiper, SwiperSlide } from 'swiper/react';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/pagination';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css/autoplay';
import SwiperCore from 'swiper';
// eslint-disable-next-line import/no-unresolved
import { Autoplay, Pagination } from 'swiper/modules';
import Cookies from 'js-cookie';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
// import { useLocation, useNavigate } from 'react-router-dom';
import useWindowSize from '../../hooks/useWindowSize';
import removeHtmlTags from '../../helpers/removeHtmlTags';
import phoneIconWhite from '../../assets/icons/phone_icon.svg';
import calendarIcon from '../../assets/icons/calendarbLUE.svg';
import callToggle from '../../store/actions/callToggle';
// import giftToggle from '../../store/actions/giftToggle';

SwiperCore.use([Autoplay]);

function BannerSlider({ data }) {
  const dispatch = useDispatch();
  // const navigate = useNavigate();
  // const location = useLocation();

  const swiperRef = useRef(null);
  const lang = Cookies.get('i18next') || 'en';
  const [currentSlide, setCurrentSlide] = useState(0);
  const { width } = useWindowSize();
  const { translations } = useSelector((state) => state.translation);
  const handleNext = () => {
    if (swiperRef.current) swiperRef.current.slideNext();
  };
  const handlePrev = () => {
    if (swiperRef.current) swiperRef.current.slidePrev();
  };
  const { t } = useTranslation();
  const pagination = {
    clickable: true,
    renderBullet(index, className) {
      return `<span class="${className}"></span>`;
    },
  };
  const handleCloseModal = () => {
    dispatch(callToggle({
      visible: true,
      isCall: true,
      item: null,
    }));
  };

  return (
    <div className="main__banner">
      {width > 768 && <div className="main__banner-blur" />}
      <div className="main__banner-wrapper">
        {width > 768 && (
          <div className="banner__slider-buttons">
            <button onClick={handlePrev} title="previus" type="button" className="banner__arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M25 8.33337L15 20L25 31.6667"
                  stroke={currentSlide === 2 ? '#005AA8' : 'white'}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
            <button onClick={handleNext} title="next" type="button" className="banner__arrow">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
              >
                <path
                  d="M15 8.33337L25 20L15 31.6667"
                  stroke={currentSlide === 2 ? '#005AA8' : 'white'}
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </button>
          </div>
        )}
        <Swiper
          allowTouchMove={(width < 768)}
          pagination={pagination}
          modules={[Pagination]}
          centeredSlides
          onSlideChange={(swiper) => setCurrentSlide(swiper.realIndex)}
          loop
          autoplay={{ delay: 300000 }}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          className=""
          spaceBetween={0}
          slidesPerView={1}
          slidesPerGroup={1}
        >
          {data.map((e, index) => (
            <SwiperSlide className="banner_slider" key={e.id}>
              <div className="banner">

                {/* ===================== 1️⃣ VIDEO ===================== */}
                {e.image.type === 'v' && (
                  <video
                    preload="none"
                    className={`banner__image ${
                      currentSlide === 4 ? 'opinion-video' : ''
                    }`}
                    autoPlay
                    loop
                    muted
                    playsInline
                  >
                    <source src={e.image.webp_url} type="video/mp4" />
                    {translations?.video_error?.[lang]}
                  </video>
                )}

                {/* ===================== 2️⃣–5️⃣ CONTENT ===================== */}
                {index !== 0 && (
                  <>
                    {/* Background Image */}
                    <div
                      style={{
                        backgroundImage: `url(${e.image.webp_url})`,
                        backgroundSize: 'cover',
                        backgroundPosition: '11% 50%',
                        backgroundRepeat: 'no-repeat',
                        width: '100%',
                        height: '100%',
                      }}
                      className={`banner__image ${
                        currentSlide === 4 ? 'opinion-video' : ''
                      }`}
                    />

                    <div
                      className={`banner__content${
                        // eslint-disable-next-line no-nested-ternary
                        currentSlide === 2
                          ? ' second'
                          : currentSlide === 3 || currentSlide === 4
                            ? ' third'
                            : ''
                      }`}
                    >

                      {/* ===================== 2️⃣ CALL + PHONE ===================== */}
                      {index === 1 && (
                        <>
                          <div className="top-header__phone slider">
                            <a href="tel:8676" className="top-header__phone-item">
                              <img src={phoneIconWhite} alt="telephone" />
                              <p>8676</p>
                            </a>
                          </div>
                          <h1 className="banner__content-title">
                            {e.title[lang]}
                          </h1>
                          <p className="banner__content-description">
                            {removeHtmlTags(e.body[lang])}
                          </p>
                          <div
                            role="presentation"
                            onClick={handleCloseModal}
                            className="header__actions-telegram call-btn slider"
                          >
                            <img src={calendarIcon} alt="callIcon" />
                            <p>{translations?.home_call?.[lang]}</p>
                          </div>
                        </>
                      )}

                      {/* ===================== 3️⃣ TELEGRAM ===================== */}
                      {index === 2 && (
                      <>
                        <h1 className="banner__content-title">
                          {e.title[lang]}
                        </h1>
                        <div className="header__actions-telegram slider">
                          <a
                            target="_blank"
                            href="https://t.me/EcoSene_bot"
                            rel="noreferrer"
                          >
                            {t('telegram_bot')}
                          </a>
                        </div>
                      </>
                      )}
                      {/* ===================== 5️⃣ SECOND OPINION ===================== */}
                      {index === 3 && (
                      <div className="slider_link">
                        <button
                          type="button"
                          onClick={() => {
                            const url = `https://germed.am/${
                              lang === 'am' ? 'hy' : lang
                            }`;
                            window.open(url, '_blank', 'noopener,noreferrer');
                          }}
                          className="header__actions-telegram slider"
                        >
                          <p>{t('buttons.second-opinion')}</p>
                        </button>
                      </div>
                      )}

                    </div>
                  </>
                )}

              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
}

export default BannerSlider;
